import { IXrayInfo, IUltrasound, ICt, IMRi, Iinterventional } from '../../rad-categories';
import { EnumGender } from '../../sharedTypes';

export interface IPatientFullForm extends IPatientInfo {
    // Scheduler Details Automatically get selected
    schedulerName: string;
    practiceName: string;
    practicePhone: string;
    providerSignature: string;
    providerName: string;

    // appointment Details
    appointmentDetails: IAppointmentDetails;

    // Imaging Categories here
    imagingCategories: Partial<{
        xRay: Partial<IXrayInfo>;
        ct: Partial<ICt>;
        ultraSound: Partial<IUltrasound>;
        mri: Partial<IMRi>;
        ir: Partial<Iinterventional>;
    }>;
}

//  ********** Patient Info **********

export enum EnumPatientInfo {
    PatientFirstName = 'patientFirstName',
    PatientMiddleName = 'patientMiddleName',
    PatientLastName = 'patientLastName',
    Date = 'registrationDate',
    Dob = 'birthDate',
    Gender = 'sex',
    ParentGuardianName = 'guardianName',
    PrimaryInsurance = 'primaryInsurance',
    PrimaryAuthNumber = 'primaryAuthNumber',
    Contact = 'contact',
    Address = 'address',
}

export interface IPatientInfo {
    [EnumPatientInfo.PatientFirstName]: string;
    [EnumPatientInfo.PatientMiddleName]: string;
    [EnumPatientInfo.PatientLastName]: string;
    [EnumPatientInfo.Date]: string;
    [EnumPatientInfo.Dob]: string;
    [EnumPatientInfo.Gender]: EnumGender | string;
    [EnumPatientInfo.ParentGuardianName]?: string;
    [EnumPatientInfo.PrimaryInsurance]: string;
    [EnumPatientInfo.PrimaryAuthNumber]: string;
    [EnumPatientInfo.Contact]: string;
    [EnumPatientInfo.Address]: string;
}

//  ********** scheduling interface **********
enum EnumScheduleType {
    OfficeToSchedule = 'Office to Schedule',
    WakeRadToSchedule = 'Wake Rad to Schedule',
}

interface IPreviousImaging {
    value: boolean;
    facility: {
        wakeRad: boolean;
        rex: boolean;
        other: string;
    };
    patientWillBring?: boolean;
}

interface IAppointmentDetails {
    scheduleType: EnumScheduleType[];
    patientHomePhone: string;
    workPhone: string;
    cellPhone: string;
    appointmentDate: string;
    appointmentTime: string;
    examLocation: string;
    previousImaging: IPreviousImaging;
}
